import React from 'react'

const OnlineTherapySection = () => {
    return (
        <div className="online-therapy-section">
            <ul>
                <li>
                    <a href={`/${document.body.dataset.site}/empresas`}>Para Empresas</a>
                </li>
                <li>
                    <a href={`/${document.body.dataset.site}/psychologists/sign_up`}>Para Psicólogos</a>
                </li>
            </ul>
        </div>
    )
}

export default OnlineTherapySection
